import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-blog-differenza-pulizie-ordinarie-straordinarie',
  imports: [CommonModule],
  templateUrl: './blog-differenza-pulizie-ordinarie-straordinarie.html',
  styleUrls: ['./blog-differenza-pulizie-ordinarie-straordinarie.scss'],
})
export class BlogDifferenzaPulizieOrdinarieStraordinarieComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Differenza tra pulizie ordinarie e straordinarie | SAMI Pulizie',
      description:
        'Scopri la differenza tra pulizie ordinarie e straordinarie: quando servono, cosa includono e quale scegliere per casa o azienda a Pescara.',
      keywords:
        'pulizie ordinarie, pulizie straordinarie, differenza pulizie, impresa di pulizie Pescara, pulizie professionali',
      canonicalUrl: '/blog/differenza-pulizie-ordinarie-straordinarie',

      ogTitle: 'Differenza tra pulizie ordinarie e straordinarie',
      ogDescription:
        'Pulizie ordinarie o straordinarie? Scopri le differenze e quando scegliere ciascun servizio.',
      ogImage: '/assets/og-sami.jpg',
      ogType: 'article',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: 'Differenza tra pulizie ordinarie e straordinarie',
        datePublished: '2025-03-15',
        dateModified: '2025-03-15',
        author: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/'
        },
        publisher: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://samipulizie.it/assets/logo.png'
          }
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://samipulizie.it/blog/differenza-pulizie-ordinarie-straordinarie'
        }
      }
    });
  }

  navigateToPreventivo() {
    this.router.navigateByUrl('/preventivo');
  }
}
